import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

export function ConfirmModal({ confirmAction, saving, onClose, onCancelSubscription, onSuspend, onDelete }) {
  if (!confirmAction) return null;

  const config = {
    cancel_sub: {
      title: 'Cancel subscription?',
      desc: 'Your subscription will be cancelled immediately. You will lose access to premium features.',
      btnLabel: 'Yes, Cancel',
      btnClass: 'bg-red-500 hover:bg-red-600',
      action: onCancelSubscription,
    },
    suspend: {
      title: 'Suspend account?',
      desc: 'Your account will be temporarily disabled. You can reactivate it by contacting support.',
      btnLabel: 'Suspend',
      btnClass: 'bg-red-500 hover:bg-red-600',
      action: () => { onSuspend(); onClose(); },
    },
    delete: {
      title: 'Delete account?',
      desc: 'This action is permanent. All your data, saved topics, and preferences will be deleted forever.',
      btnLabel: 'Delete Forever',
      btnClass: 'bg-red-600 hover:bg-red-700',
      action: () => { onDelete(); onClose(); },
    },
  };

  const cfg = config[confirmAction];
  if (!cfg) return null;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-5"
      onClick={onClose}>
      <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }} exit={{ scale: 0.9 }}
        onClick={e => e.stopPropagation()} className="bg-white rounded-2xl p-6 w-full max-w-sm">
        <h3 className="text-lg font-bold text-gray-900 mb-2">{cfg.title}</h3>
        <p className="text-sm text-gray-400 mb-5">{cfg.desc}</p>
        <div className="flex gap-2">
          <button onClick={onClose}
            className="flex-1 py-3 rounded-xl bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200 transition-all">Keep</button>
          <button data-testid="confirm-action" onClick={cfg.action}
            className={`flex-1 py-3 rounded-xl text-white text-sm font-semibold transition-all ${cfg.btnClass}`}>
            {saving ? <Loader2 size={16} className="animate-spin mx-auto" /> : cfg.btnLabel}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
